export default "__VITE_ASSET__DlvAUaky__"